import {useMutation} from '@tanstack/react-query';
import {AxiosError} from 'axios';
import axiosInstance from '../../../axiosConfig';
import {ISharedMessageType} from '../../../dto/MessageSharing.dto';
import {AxiosErrorToast} from '../../general/ReusableFunctions';

const unshareMessage = (
  companyId: number,
  messageType: ISharedMessageType,
  requestId: number,
) => {
  return axiosInstance
    .delete(
      `/v1/company/${companyId}/message/${messageType}/${requestId}/share`,
    )
    .then(() => {
      return;
    })
    .catch((error: AxiosError) => {
      AxiosErrorToast(error, 'Error unsharing message');
      throw error;
    });
};

export const useRqUnshareMessage = (
  companyId: number,
  messageType: ISharedMessageType,
  requestId: number,
) => {
  return useMutation({
    mutationFn: () => unshareMessage(companyId, messageType, requestId),
  });
};
